import { ApplicationSetting } from './application.setting';
import { SettingsSection } from './settings-section.model';

export class ApplicationSettings {
  public applicationName: string;
  public sections: Array<SettingsSection>;

  constructor(applicationSetting: ApplicationSetting) {
    this.applicationName = applicationSetting.applicationName;
    this.sections = applicationSetting.sections;
  }
}

export interface ApplicationSetting {
  applicationName: string;
  sections: Array<SettingsSection>;
}
